var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThemeLight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 100,
    viewBox: "0 0 150 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 100,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 149,
    height: 14,
    stroke: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 14.5,
    width: 14,
    height: 85,
    stroke: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.5,
    y: 14.5,
    width: 135,
    height: 85,
    fill: "#EBEBEB",
    stroke: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.5,
    y: 28.5,
    width: 106,
    height: 26,
    rx: 2.5,
    fill: "white",
    stroke: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.5,
    y: 63.5,
    width: 106,
    height: 26,
    rx: 2.5,
    fill: "white",
    stroke: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3333 62.3333C76.7222 62.3333 77.9028 61.8472 78.875 60.875C79.8472 59.9028 80.3333 58.7222 80.3333 57.3333C80.3333 55.9444 79.8472 54.7639 78.875 53.7917C77.9028 52.8194 76.7222 52.3333 75.3333 52.3333C73.9444 52.3333 72.7639 52.8194 71.7917 53.7917C70.8194 54.7639 70.3333 55.9444 70.3333 57.3333C70.3333 58.7222 70.8194 59.9028 71.7917 60.875C72.7639 61.8472 73.9444 62.3333 75.3333 62.3333ZM75.3333 65.6667C73.0278 65.6667 71.0625 64.8542 69.4375 63.2292C67.8125 61.6042 67 59.6389 67 57.3333C67 55.0278 67.8125 53.0625 69.4375 51.4375C71.0625 49.8125 73.0278 49 75.3333 49C77.6389 49 79.6042 49.8125 81.2292 51.4375C82.8542 53.0625 83.6667 55.0278 83.6667 57.3333C83.6667 59.6389 82.8542 61.6042 81.2292 63.2292C79.6042 64.8542 77.6389 65.6667 75.3333 65.6667ZM63.6667 59H57V55.6667H63.6667V59ZM93.6667 59H87V55.6667H93.6667V59ZM73.6667 45.6667V39H77V45.6667H73.6667ZM73.6667 75.6667V69H77V75.6667H73.6667ZM66 50.25L61.7917 46.2083L64.1667 43.75L68.1667 47.9167L66 50.25ZM86.5 70.9167L82.4583 66.7083L84.6667 64.4167L88.875 68.4583L86.5 70.9167ZM82.4167 48L86.4583 43.7917L88.9167 46.1667L84.75 50.1667L82.4167 48ZM61.75 68.5L65.9583 64.4583L68.25 66.6667L64.2083 70.875L61.75 68.5Z",
    fill: "#28AC47"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThemeLight);
export default __webpack_public_path__ + "static/media/theme-light.b6e454e7f17fccec1109ceba109a4292.svg";
export { ForwardRef as ReactComponent };